// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"1e5347b5","611":"dc776575","988":"2dc61c48"}[chunkId] + ".chunk.js";
};